export const VIGO_MASTER_QUOTATION_EN = {
  title: 'Vigo Master Quotation',
  vigoMasterNumber: 'Vigo Master Quotation Number',
  all: 'ALL',
  request_high_level_approved: 'NEED APPROVE LEVEL 2',
  pending: 'PENDING',
  awaiting_logistics: 'AWAITING LOGISTICS',
  awaiting_approval: 'AWAITING APPROVAL',
  closed: 'CLOSED',
  number: 'Master Quotation Number',
  selectSuppliers: 'Select Suppliers',
  contentSelectSuppliers: 'Choose Suppliers and Order Quantity',
  arrangeLogistics: 'Arrange Logistics',
  contentArrangeLogistics: "For delivery Supplier doesn't support",
  approval: 'Approval',
  contentApproval: 'Discount and Approval',
  issueQuotation: 'Issue Quotation',
  contentIssueQuotation: "For Distributor's PRs",
  editByBatch: 'Edit By Batch Number',
  updateQuantityByBatch: 'Update Quantity By Batch Number',
  viewTermAndCondition: 'View Terms and Conditions',
  withShip: 'With Ship',
  withoutShip: 'Without Ship',
  competitorPrice: 'Competitor Price',
  maxQuantitySuggest: 'Max Quantity Suggest:',
  soldQuantity: 'Sold Quantity:',
  currentInventory: 'Current Inventory:',
  estimateStockPerDay: 'Estimate Stock Per Day:',
  payToSupplier: 'Pay to supplier',
  contentPayment: 'Pay the supplier before delivery?',
  supplierName: 'Supplier Name',
  pay_after_delivery: 'After Delivery',
  pay_before_delivery: 'Before Delivery',
  pendingRouter: 'Pending Routers',
  sort: 'Sort',
  fromSupplier: 'From-Supplier',
  toDistributor: 'To-Distributor',
  estimateWeight: 'Estimate Weight (kg)',
  deliveryPartner: 'Delivery Partner',
  deliveryGroup: 'Delivery Group',
  confirmArrange: 'Arrange Log & Next',
  distributor_pickup: 'Distributor Pickup',
  newVigoDelivery: 'New Vigo Delivery Summary',
  noOfRoute: 'No. of routes',
  estimateCost: 'Estimated Cost',
  pricePerTon: 'Price / Ton',
  deliveryDiscount: 'Delivery Discount',
  confirmDeadline: 'Confirm Deadline',
  suggestedDeliveryGroup: 'Suggested Delivery Group',
  estCost: 'Estimated Cost',
  totalDelivery: 'Total Delivery',
  purchasedPrice: 'Purchased Price',
  bidding: 'BIDDING',
  pricing: 'PRICING MODEL',
  retail: 'Retail',
  trading: 'Trading',
  consignment: 'Consignment',
  errorSelect: 'Please select suppliers for all SKUs!',
  qty: 'Quantity',
  firstMile: 'First Mile',
  cogs: 'VAT COGS Invoice',
  marketSurveyPurchasePrice: 'Market survey purchase price',
  applyMarginStandard: 'Apply Margin Standard',
  adjustmentSellingPriceOnApp: 'Adjustment sell price on app',
  adjustmentSACommission: 'Adjustment SA commission',
  adjustmentPriceWithDistributor: 'Adjustment price with Distributor',
  marginAfterCorrection: 'Margin after correction',
  estimatedReferenceSellingPriceOnApp:
    'Estimated reference sell-price on the app',
  marketSurveyPriceMin: 'Market survey price min',
  marketSurveyPriceMax: 'Market survey price max',
  distributorSupportPrice: 'Distributor support price',
  referenceSellingPriceOnAppFinal: 'Reference sell-price on app final',
  distributorTC: 'Distributor T&C',
  sACommission: 'SA Commission',
  sACommissionFinal: 'SA Commission final',
  vigoBudget: 'Vigo Budget',
  percentCM3Expected: '%CM3 Expected',
  cM3Expected: 'CM3 expected',
  vigoMissionFeeProvisionallyCollected:
    'Vigo mission fee provisionally collected',
  vigoMissionFeeProvisionallyCollectedFinal:
    'Vigo mission fee provisionally collected final',
  surveyAmplitude: 'Survey amplitude',
  surveyAmplitudeFinal: 'Survey amplitude final',
  vigoPurchasePriceSurvey: 'Vigo purchase price survey',
  vigoPurchasePriceSurveyFinal: 'Vigo purchase price survey final',
  surveySellingPriceToDistributor: 'Survey sell price to Distributor',
  surveySellingPriceToDistributorFinal:
    'Survey sell price to Distributor final',
  markupPrice: 'Markup price',
  controlTypeOfMarkupPrice: 'Control type of markup price',
  specialSubsidyOnCase: 'Special Subsidy / case',
  specialTCDistributorOnCase: 'Special T&C distributor / case',
  purchasePriceVigoAcceptToBuy: 'Purchase price Vigo accept to buy',
  surveyPriceDifference: 'Survey price difference',
  referenceSellingPriceForDistributor: 'Reference sell- price for distributor',
  priceVigoAgreesToSellToDistributor:
    'Price Vigo agrees to sell to distributor',
  minimumRecommendedPriceOnApp:
    'Trading : Survey selling price Retail DPO,Retail SDPO, Consignment : Minimum recommended price on App (according to survey)',
  maximumRecommendedPriceOnApp:
    'Trading : Listed selling price Retail DPO,Retail SDPO, Consignment : Maximum recommended price on App (according to survey)',
  totalSACommission: 'Total SA commission',
  verifyCM3: 'Verify CM3',
  percentCM3: '% CM3',
  interactiveMission: 'Interactive Mission',
  weeklyBonus: 'Weekly bonus',
  estimatedDistributorBudget: 'Estimated  distributor budget',
  verifyCM3WithoutVAT: 'Verify CM3 without VAT',
  percentCM3WithoutVAT: '% CM3 without VAT',
  percentCM1WithoutVAT: '% CM1 without VAT',
  percentCM2WithoutVAT: '% CM2 without VAT',
  deposit: 'Deposit',
  specialSASubsidyOnCase: 'Special SA subsidy / case',
  finalBaseMargin: 'Final base margin',
  specialCommissionType: 'Special Commission Type',
  supplierCode: 'Supplier',
  supplier_delivery: 'Supplier Delivery',
  titleCode37Trading: 'Survey selling price',
  titleCode37RetailAndConsignment:
    'Minimum recommended price on App (according to survey)',
  titleCode38Trading: 'Listed selling price',
  titleCode38RetailAndConsignment:
    'Maximum recommended price on App (according to survey)',
  informationSave:
    'Data has not been saved. Changes are temporary for pricing model recalculation and only saved when the Confirm button is clicked.',
  extraCommissionTypeAffiliate: 'Extra Commission Value Affiliate',
  extraCommissionTypeInHouse: 'Extra Commission Value In-House',
  extraCommissionTypeWholesaleAgent: 'Extra Commission Value Wholesale Agent',
  extraCommissionTypeDistributorAgent:
    'Extra Commission Value Distributor Agent',
  extraCommissionTypeBGM: 'Extra Commission Value BGM',
}
